export default __webpack_public_path__ + "static/M-9bdf707abcbf1e346b19e9b560129d5b.png";